import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { EpisodeState } from './types'
import state from './state'
import getters from './getters'
import mutations from './mutations'

const module: Module<EpisodeState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
}

export default module
